// import { useCallback, useMemo, useState } from "react"
// import { LoadingComponent } from "../../../components/loading/loading.component"
// import { TableComponent } from "../../../components/table/table.component"
// import { useDataProvider, useDataProviderPaginated } from "../../../hooks/data-provider/data-provider.hook"
import moment from 'moment';
import { AppErrorBoundaryComponent } from '../../../../components/error-boundary/app-error-boundary.component';
import { AppTabularColumn } from '../../../../components/reports/dtos/app-tabular.dto';
import { GenericTableComponent } from '../../../../components/reports/generic-table/generic-table.component';
import { ReportsComponentProps } from '../../../../components/reports/interfaces/reports-component-props';
import { SortBy } from '../../../../interfaces/sort-by.interface';
import { DEFAULT_DATE_FORMAT } from '../../../../utils/formatting/date-formatter.helper';
import {
  formatNumber,
  formatPercNumber,
} from '../../../../utils/formatting/number-formatter.helper';
//import { createColumnHelper } from "@tanstack/react-table"

//const columnHelper = createColumnHelper<Record<string, any>>()

interface CellProps {
  data: any;
  col: AppTabularColumn;
}
const CellNumberComponent = ({ data, col }: CellProps) => {
  const value = data ? data[col.id] : 0;
  let formattedValue = value;
  if (col.format === 'percentage') {
    formattedValue = `${formatPercNumber(formattedValue * 100)}%`;
  } else {
    formattedValue = formatNumber(formattedValue);
  }
  return <div>{formattedValue}</div>;
};
interface DecompModelTableComponentProps extends ReportsComponentProps {
  height: number;
  totalReportId: string;
  defaultSortBy?: SortBy[];
  showTotal?: boolean;
}

const parseColumns = (state: AppTabularColumn[]) => {
  if (state === undefined) return [];
  return state.map((col: AppTabularColumn, index: number) => {
    const accessorFn = (row: any) =>
      col.datatype === 'DATETIME'
        ? moment(row[col.id]).format(col.format ?? DEFAULT_DATE_FORMAT)
        : row[col.id];
    //const conf = columnsConf[col.propertyName]
    //console.log("COL", col)

    return {
      header: col.name,
      footer: 'Total',
      id: col.id,
      accessorFn,
      size: 150,
      isSorted: index === 0,
      //, ...conf
    };
  });
};
const parseMeasuresColumns = (
  state: AppTabularColumn[],
  data: any,
  total?: any,
) => {
  if (state === undefined) return [];
  return state.map((col: AppTabularColumn, index: number) => {
    const accessorFn = (row: any) => formatNumber(row[col.id]);
    //const conf = columnsConf[col.propertyName]
    return {
      header: col.name,
      footer: () => <CellNumberComponent data={total} col={col} />,

      id: col.id,

      accessorFn,
      size: 150,
      isSorted: index === 0,
      meta: {
        align: 'right',
      },
    };
  });
};
export const DecompModelTableComponent = ({
  filterSelection,
  reportName: reportId,
  totalReportId,
  enabled,
  height,
  defaultSortBy,
  showTotal,
}: DecompModelTableComponentProps) => {
  return (
    <div className={'decomp-model-table'}>
      <AppErrorBoundaryComponent>
        <GenericTableComponent
          defaultSortBy={defaultSortBy}
          enabled={enabled}
          height={height}
          reportName={reportId}
          totalReportName={totalReportId}
          filterSelection={filterSelection}
          parseColumns={parseColumns}
          parseMeasuresColumns={parseMeasuresColumns}
          showTotal={showTotal}
        />
      </AppErrorBoundaryComponent>
    </div>
  );
};
